import React, { useContext } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import {
  CartStateContext,
  CartDispatchContext,
  toggleCartPopup
} from "contexts/cart";
import {
  ProductsStateContext, 
  ProductsDispatchContext,
  getProducts
} from "contexts/products";
import { CommonDispatchContext, setSearchKeyword } from "contexts/common";
import CartPreview from "components/CartPreview";
import Overlay from 'react-bootstrap/Overlay';
import zIndex from "@material-ui/core/styles/zIndex";

const Header = (props) => {
  const { products:cartItems, isLoading, isLoaded } = useContext(ProductsStateContext);
  const commonDispatch = useContext(CommonDispatchContext);
  const cartDispatch = useContext(CartDispatchContext);
  // console.log(cartItems,':::::::>')
  // console.log(rows)
  var cartQuantity = 0;
  const cartfilter =  cartItems.filter( id => id.quantity > 0)
  // console.log(cartfilter)
  if (cartfilter) {
    cartQuantity = cartfilter.length;
  }
   //
  
  const cartDiscountTotal = cartItems
    .map((item) => item.discountprice * item.quantity)
    .reduce((prev, current) => prev + current, 0).toFixed(1);
  const cartTotal = cartItems
  .map((item) => item.price * item.quantity)
  .reduce((prev, current) => prev + current, 0).toFixed(1);
  var saving = cartTotal - cartDiscountTotal
  saving = saving.toFixed(1)
  const handleSearchInput = (event) => {
    return setSearchKeyword(commonDispatch, event.target.value);
  };

  const handleCartButton = (event) => {
    event.preventDefault();
    return toggleCartPopup(cartDispatch);
  };

  return (

    <header>
      <div
            // {...props}
            style={{
              position: 'absolute',

              zIndex: 0,
              left: "0%",
              top: "30%",
              // ...props.style,
            }}
          >
          <img style={{maxWidth:"35%",height:"auto"}}src='534320_791f5.gif'></img>
          </div>
          <div
            // {...props}
            style={{
              position: 'absolute',

              zIndex: 0,
              left: "8%",
              top: "-10%",
              // ...props.style,
            }}
          >
          <img style={{maxWidth:"30%",height:"auto"}}src='534324_71cd8.gif'></img>
          </div>
          <div
            // {...props}
            style={{
              position: 'absolute',

              zIndex: 0,
              left: "8%",
              top: "20%",
              // ...props.style,
            }}
          >
          <img style={{maxWidth:"35%",height:"auto"}}src='534320_791f5.gif'></img>
          </div>
          
          <div
            // {...props}
            style={{
              position: 'absolute',

              zIndex: 0,
              left: "-2%",
              top: "0%",
              // ...props.style,
            }}
          >
          <img style={{maxWidth:"30%",height:"auto"}}src='53.gif'></img>
          </div>
                <div className="container">
      
        <div className="brand">
        
          <Link to="/">
          {/* <Overlay show={true} placement="auto"> */}
        {/* {({ placement, arrowProps, show, popper, ...props }) => ( */}
          
        {/* )} */}
      {/* </Overlay> */}
            <img
              className="logo"
              src="70250187927_2.png"
              alt="Ak Logo"
            />
            
          </Link>
        </div>

        <div style={{zIndex: 1}} className="search">
        <input
              type="search"
              placeholder="Search for Crackers"
              className="mobile-search"
              onChange={handleSearchInput}
            />
          <form action="#" method="get" className="search-form">
            <a
              className="back-button"
              href="#"
              // onClick={this.handleSearchNav.bind(this)}
            >
              <img
                src=""
                alt="back"
              />
            </a>
            <input
              type="search"
              placeholder="Search for Crackers"
              className="search-keyword"
              onChange={handleSearchInput}
            />
            <button
              className="search-button"
              type="submit"
              // onClick={this.handleSubmit.bind(this)}
            />
          </form>
        </div>

        <div className="cart">
          <div className="cart-info">
            <table>
              <tbody>
                {/* <tr>
                  <td>Items</td>
                  <td>:</td>
                  <td>
                    <strong>{cartQuantity}</strong>
                  </td>
                </tr> */}
                <tr >
                  <td>Total</td>
                  <td>:</td>
                  <td>
                    <strong style={{textDecoration: "line-through"}}> ₹{cartTotal}</strong>
                  </td>
                </tr>
                <tr>
                  <td>Saving(50%off)</td>
                  <td>:</td>
                  <td>
                    <strong> -₹{saving}</strong>
                  </td>
                </tr>
                <tr>
                  <td>Total Discount Price</td>
                  <td>:</td>
                  <td>
                    <strong> ₹{cartDiscountTotal}</strong>
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
          <a className="cart-icon" href="#" onClick={handleCartButton}>
            <img
              className={props.cartBounce ? "tada" : " "}
              src="fastcart.png"
              alt="Cart"
            />
            {cartQuantity ? (
              <span className="cart-count">{cartQuantity}</span>
            ) : (
              ""
            )}
            
          </a>
          
          <CartPreview />
          
        </div>
        
        
      </div>
      
      </header>
      
      );
};

export default Header;
